import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({
  searchQuery,
  onSearchChange,
  mediaType,
  onMediaTypeChange,
  sortBy,
  onSortByChange,
  viewMode,
  onViewModeChange,
  selectedCount,
  onClearSelection,
  onDownloadSelected,
  onSelectAll,
  totalCount,
  canDownload = true
}) => {
  const mediaTypeOptions = [
    { value: 'all', label: 'All Media' },
    { value: 'image', label: 'Photos Only' },
    { value: 'video', label: 'Videos Only' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'size-desc', label: 'Largest First' },
    { value: 'size-asc', label: 'Smallest First' }
  ];

  const isAllSelected = selectedCount > 0 && selectedCount === totalCount;

  return (
    <div className="space-y-4">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search media by title or description..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
            aria-label="Search media"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <Select
            options={mediaTypeOptions}
            value={mediaType}
            onChange={onMediaTypeChange}
            className="w-full sm:w-40"
            aria-label="Filter by media type"
          />

          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortByChange}
            className="w-full sm:w-48"
            aria-label="Sort media"
          />

          <div className="flex gap-2">
            <Button
              variant={viewMode === 'grid' ? 'default' : 'outline'}
              size="icon"
              onClick={() => onViewModeChange('grid')}
              aria-label="Grid view"
              title="Grid view"
            >
              <Icon name="Grid3x3" size={20} />
            </Button>
            <Button
              variant={viewMode === 'list' ? 'default' : 'outline'}
              size="icon"
              onClick={() => onViewModeChange('list')}
              aria-label="List view"
              title="List view"
            >
              <Icon name="List" size={20} />
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={onSelectAll}
              className="ml-2"
              aria-label={isAllSelected ? 'Deselect all media' : 'Select all media'}
            >
              <Icon name={isAllSelected ? "XCircle" : "CheckSquare"} size={18} className="mr-2" />
              {isAllSelected ? 'Deselect All' : 'Select All'}
            </Button>
          </div>
        </div>
      </div>
      {selectedCount > 0 && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 rounded-xl bg-primary/10 border border-primary/20">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
              <Icon name="Check" size={20} color="white" />
            </div>
            <div>
              <p className="text-sm md:text-base font-medium">
                {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
              </p>
              <p className="text-xs md:text-sm text-muted-foreground">
                Ready for download
              </p>
            </div>
          </div>

          <div className="flex gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={onClearSelection}
              className="flex-1 sm:flex-none"
            >
              Clear Selection
            </Button>
            {canDownload && (
              <Button
                variant="default"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={onDownloadSelected}
                className="flex-1 sm:flex-none"
              >
                Download Selected
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterBar;